import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

import type { Entity } from '@models/Entity'

import type { HoofdleidingProject } from '../../../../hoofdleiding/project/types/HoofdleidingProject'
import { StyledError } from '../../../../theme/components/StyledError'
import { useCreateSubprocesForEntity } from '../../hooks/useCreateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'

interface Props {
  entity: Entity
  project: HoofdleidingProject
  onClose: () => void
}

export const CreateNetcheck = ({ entity, project, onClose }: Props) => {
  const { mutate: createSubprocesForEntity, error } =
    useCreateSubprocesForEntity()

  const onSubmitClick = () => {
    const proces: Partial<Subproces> = {
      type: 'netcheck',
      assignedTo: project.verantwoordelijken[0],
      status: 'criteria_klant_verzamelen',
    }

    const body = {
      entity,
      subprocesInfo: proces,
    }

    createSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Grid container spacing={1}>
          <Grid size={{ xs: 6 }}>
            <TextField
              label="Toegewezen aan"
              variant="standard"
              value={project.verantwoordelijken[0]}
              disabled
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button onClick={onSubmitClick} variant={'contained'}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
